import { MonthlyProductType } from '../../../../license/types/MonthlyProductType';

export enum PackageGeneralEvent {
  OnCompanySelect = 'onCompanySelect',
  OnOperationModeSelect = 'onOperationModeSelect',
}

export class OnOperationModeSelect extends CustomEvent<{ productType: MonthlyProductType }> {
  constructor(productType: MonthlyProductType) {
    super(PackageGeneralEvent.OnOperationModeSelect, {
      detail: {
        productType,
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnCompanySelect extends CustomEvent<{ companyId: string }> {
  constructor(companyId: string) {
    super(PackageGeneralEvent.OnCompanySelect, {
      detail: {
        companyId,
      },
      bubbles: true,
      composed: true,
    });
  }
}
